/*
  Builds "Sisallysluettelo" (table of contents) for blog articles.
  Scans the article body's h2/h3 headings, assigns anchor ids, and fills the
  empty placeholder rendered by snippets/article-toc.liquid with a linked list.
  Skipped entirely when an article has fewer than 2 headings.

  This script tag is deferred and placed after theme.js in layout/theme.liquid,
  so by the time it runs the DOM is fully parsed - no need to wait for
  DOMContentLoaded (see assets/grid-quick-add.js for the same reasoning).
*/
(function initArticleToc() {
  var toc = document.querySelector('[data-article-toc]');
  var body = document.querySelector('.article__body');
  if (!toc || !body) return;

  var headings = Array.prototype.slice.call(body.querySelectorAll('h2, h3')).filter(function (h) {
    return h.textContent.trim().length > 0;
  });
  if (headings.length < 2) return;

  var usedIds = {};
  function slugify(text) {
    var base = text
      .toLowerCase()
      .replace(/ä/g, 'a')
      .replace(/ö/g, 'o')
      .replace(/å/g, 'a')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'osio';
    var slug = base;
    var i = 1;
    while (usedIds[slug]) {
      slug = base + '-' + i;
      i++;
    }
    usedIds[slug] = true;
    return slug;
  }

  var list = document.createElement('ol');
  list.className = 'article-toc__list';

  headings.forEach(function (heading) {
    if (!heading.id) {
      heading.id = slugify(heading.textContent.trim());
    }
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + heading.id;
    a.textContent = heading.textContent.trim();
    li.appendChild(a);
    list.appendChild(li);
  });

  var title = document.createElement('p');
  title.className = 'article-toc__title';
  title.textContent = 'Sisällysluettelo';

  toc.appendChild(title);
  toc.appendChild(list);
  toc.hidden = false;
})();
